<template>
  <el-container>
    <el-header style="height: 80px">
      <master-head-navigation />
    </el-header>
    <Index v-if="show"></Index>
    <Indexyinglu v-if="isYinglu"></Indexyinglu>
    <Index-carrier v-if="showCarrier"></Index-carrier>
    <Index-entrust v-if="showEntrust"></Index-entrust>
    <Index-tax v-if="showTax"></Index-tax>
    <customer-service v-show="ishow"></customer-service>
    <el-main class="main" v-if="showMain">
      <keep-alive>
        <router-view router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <!-- <keep-alive :include="includedComponents">
        <router-view></router-view>
      </keep-alive> -->
    </el-main>
    <el-footer style="height: auto">
      <master-bottom />
    </el-footer>
  </el-container>
</template>
<script>
import MasterHeadNavigation from "@/components/master/master-head-navigation";
import MasterHeadPosition from "@/components/master/master-head-position";
import MasterBottom from "@/components/master/master-bottom";
import Index from "@/views/index";
import IndexCarrier from "@/views/index-carrier";
import IndexEntrust from "@/views/index-entrust";
import Indexyinglu from "@/views/index-yinglu";
import IndexTax from "@/views/index-tax";
import { isSuccess, isLogin, doalogBlack } from "@/assets/js/utils";
import customerService from "@/components/customer/customer-service";
export default {
  data() {
    return {
      show: null, //合伙
      showCarrier: null,
      showEntrust: null,
      showTax: null, //财税
      showMain: true,
      // classA: 'main-bd',
      department_names: [],
      ishow: false,
      isYinglu: false,
      url: "",
      _this: this,
    };
  },
  created() {
    if (
      this.$route.path !== "/oauth/pay-forget" &&
      this.$route.path !== "/oauth/register-personal" &&
      this.$route.path !== "/oauth/register-company"
    ) {
      this.loadList();
    }
    if (this.$route.query.type == "warning") {
      this.$alert(
        "您的密码设置过于简单, 为了您的账号安全,请变更密码!",
        "提示",
        {
          confirmButtonText: "修改密码",
          callback: (action) => {
            toUrl("/oauth/update-password?type=warning");
          },
        }
      );
    }
    if (isLogin()) {
      this.ishow = true;
    } else {
      this.ishow = false;
    }
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll, true)
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path == "/") {
          this.loadList();
        } else {
          this.show = false;
          this.showCarrier = false;
          this.showEntrust = false;
          this.showTax = false;
          this.isYinglu = false;
          this.showMain = true;
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    //
    getYinglu() {
      _global_.LOGIN_INFO.department_names.forEach((item) => {
        if (item == "快销部" && _global_.UI.app_id == "44787388") {
          (this.show = false),
            (this.showCarrier = false),
            (this.showEntrust = false);
          this.sowTax = false;
          this.ishow = false;
          this.isYinglu = true;
        }
      });
    },
    loadList() {
      api("auth.login.info").then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          //黑名单用户提示
          if (data.is_black == "Yes") {
            this.$confirm(
              "黑名单用户，系统将限制您的部分操作权限！如果问题，请联系平台管理员。",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {})
              .catch(() => {});
          }
          if (data.is_auth == "NotAttestation") {
            this.$confirm(
              "尊敬的用户您好，欢迎使用我家互联网物流运输平台，您还未认证，请尽快提交认证。",
              "温馨提示",
              {
                confirmButtonText: "去认证",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                toUrl("/center/auth");
              })
              .catch(() => {});
          }
          this.parent_dep_codes = data.parent_dep_codes;
          if (this.$route.path == "/") {
            this.showMain = false;
            //合同时拥有委托方/承运方/  就展示合伙人
            if (
              this.parent_dep_codes.indexOf("SHIPPER") !== -1 &&
              this.parent_dep_codes.indexOf("DELEGATE") !== -1
            ) {
              this.show = true;
              this.showCarrier = false;
              this.showEntrust = false;
              this.showTax = false;
              //同时拥有承运方/财务业务  就展示承运方
            } else if (
              this.parent_dep_codes.indexOf("SHIPPER") !== -1 &&
              this.parent_dep_codes.indexOf("FINANCE") !== -1
            ) {
              this.show = false;
              this.showCarrier = true;
              this.showEntrust = false;
              this.showTax = false;
              //单个角色
            } else if (
              this.parent_dep_codes.indexOf("SHIPPER") !== -1 &&
              this.parent_dep_codes.indexOf("DELEGATE") == -1 &&
              this.parent_dep_codes.indexOf("FINANCE") == -1 &&
              this.parent_dep_codes.indexOf("PARTNERSHIP") == -1
            ) {
              this.show = false;
              this.showCarrier = true;
              this.showEntrust = false;
              this.showTax = false;
            } else if (
              this.parent_dep_codes.indexOf("SHIPPER") == -1 &&
              this.parent_dep_codes.indexOf("DELEGATE") == -1 &&
              this.parent_dep_codes.indexOf("FINANCE") !== -1 &&
              this.parent_dep_codes.indexOf("PARTNERSHIP") == -1
            ) {
              this.show = false;
              this.showCarrier = false;
              this.showEntrust = false;
              this.showTax = true;
            } else if (
              this.parent_dep_codes.indexOf("SHIPPER") == -1 &&
              this.parent_dep_codes.indexOf("DELEGATE") == -1 &&
              this.parent_dep_codes.indexOf("FINANCE") == -1 &&
              this.parent_dep_codes.indexOf("PARTNERSHIP") !== -1
            ) {
              this.show = true;
              this.showCarrier = false;
              this.showEntrust = false;
              this.showTax = false;
            } else {
              //同时拥有委托方/财务业务  就展示委托方  若为自定义的校色  就展示委托方
              this.show = false;
              this.showCarrier = false;
              this.showEntrust = true;
              this.showTax = false;
            }
          } else {
            this.show = false;
            this.showCarrier = false;
            this.showEntrust = false;
            this.showTax = false;
            this.showMain = true;
          }
        }
        this.getYinglu();
      });
    },
    // handleScroll () {
    //   //变量scrollTop是滚动条滚动时，距离顶部的距离
    //   var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    //   //变量windowHeight是可视区的高度
    //   var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //   //变量scrollHeight是滚动条的总高度
    //   var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    //   //滚动条到底部的条件
    //   let sum = scrollHeight - (scrollTop + windowHeight)
    //   console.log(scrollTop)
    //   if (scrollTop > 0) {
    //     if (sum > 200) {
    //       this.classA = 'main-bd'
    //     } else {
    //       this.classA = 'main-bdd'
    //     }
    //   }
    // },
  },
  components: {
    MasterHeadNavigation,
    MasterHeadPosition,
    MasterBottom,
    Index,
    IndexEntrust,
    IndexTax,
    IndexCarrier,
    customerService,
    Indexyinglu,
  },
};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/views/main.vue